import { useRef, useState } from 'react';
import { vues, compresser, blobEnDataUrl } from '../lib/photos';
import { T } from '../i18n';

export interface PhotoPrise { vue: string; dataUrl: string; taille: number }

/**
 * Les six prises de vue du contrat. L'appareil photo du telephone s'ouvre
 * directement (capture="environment"), l'image est compressee sur place,
 * et l'agent voit un compteur `n/6` — pas un formulaire a deviner.
 */
export function PhotosEdl({ photos, onChange }:
  { photos: PhotoPrise[]; onChange: (p: PhotoPrise[]) => void }) {
  const refs = useRef<Record<string, HTMLInputElement | null>>({});
  const [occupe, setOccupe] = useState<string | null>(null);
  const [erreur, setErreur] = useState('');

  async function choisir(vue: string, fichier?: File) {
    if (!fichier) return;
    setOccupe(vue); setErreur('');
    try {
      const blob = await compresser(fichier);
      const dataUrl = await blobEnDataUrl(blob);
      onChange([...photos.filter((p) => p.vue !== vue), { vue, dataUrl, taille: blob.size }]);
    } catch {
      setErreur(T.photosEdl.erreurImage);
    } finally { setOccupe(null); }
  }

  const prises = photos.length;
  const poids = photos.reduce((a, p) => a + p.taille, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
        <span className="lbl">{T.photosEdl.titre}</span>
        <span className="mini" style={{ fontWeight: 700, color: prises >= 6 ? 'var(--succes)' : 'var(--attention)' }}>
          {prises}/6
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,minmax(0,1fr))', gap: 8 }}>
        {vues().map((v) => {
          const p = photos.find((x) => x.vue === v.cle);
          return (
            <div key={v.cle}>
              <input ref={(el) => { refs.current[v.cle] = el; }} type="file" accept="image/*" capture="environment"
                     style={{ display: 'none' }} onChange={(e) => void choisir(v.cle, e.target.files?.[0])} />
              <button type="button" onClick={() => refs.current[v.cle]?.click()}
                      style={{
                        width: '100%', aspectRatio: '4/3', borderRadius: 'var(--r-champ)', cursor: 'pointer',
                        border: p ? '2px solid var(--succes)' : '1px dashed var(--bord-fort)',
                        background: p ? `center/cover no-repeat url(${p.dataUrl})` : 'var(--fond)',
                        display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: 0, overflow: 'hidden',
                      }}>
                <span style={{
                  width: '100%', fontSize: 11, fontWeight: 600, padding: '3px 4px',
                  background: p ? 'rgba(15,27,45,.72)' : 'transparent', color: p ? '#fff' : 'var(--texte3)',
                }}>
                  {occupe === v.cle ? '…' : v.label}
                </span>
              </button>
              {p && (
                <button type="button" className="btn btn-s btn-f" style={{ width: '100%', marginTop: 2 }}
                        onClick={() => onChange(photos.filter((x) => x.vue !== v.cle))}>
                  {T.photosEdl.retirer}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {erreur && <div className="mini" style={{ color: 'var(--danger)', marginTop: 6 }}>{erreur}</div>}
      <p className="mini sourdine" style={{ marginTop: 8 }}>
        {T.photosEdl.explication(Math.round(poids / 1024))}

      </p>
    </div>
  );
}
